
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/contact-form",
      function () {
        return require("private-next-pages/support/contact-form/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/contact-form"])
      });
    }
  